/* Actions*/
export const SAVE_INSTANCE = "SAVE_INSTANCE";
export const REMOVE_INSTANCE = "REMOVE_INSTANCE";
export const UPDATE_INSTANCE = "UPDATE_INSTANCE";
/*-----------*/
export const SAVE_INSTANCE_ARRAY = "SAVE_INSTANCE_ARRAY";
export const UPDATE_INSTANCE_FROM_ARRAY = "UPDATE_INSTANCE_FROM_ARRAY ";
export const REMOVE_INSTANCE_FROM_ARRAY = "REMOVE_INSTANCE_FROM_ARRAY";
